import React, {useState} from 'react';
import cx from 'classnames';
import {
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonTitle,
    IonIcon,
    IonActionSheet,
    IonBackButton,
} from '@ionic/react';
import {ellipsisVertical} from 'ionicons/icons';
import {connect} from "react-redux";
import {useTranslation} from 'react-i18next';
import ChatOpenWindow from "./ChatOpenWindow";


const CommonHeader = (
    {
        title = '',
        component,
        listSettings = [],
        defaultHref = '/chats',
        onBackButtonClick = null,
        activeShop,
        networkState,
    }
) => {



    const [showActionSheet, setShowActionSheet] = useState(false);

    const elementHeader = component ? component : <IonTitle>{title}</IonTitle>;

    const elementSettings = listSettings.length ? <>
        <IonButtons slot="end">
            <ChatOpenWindow/>
            <IonButton onClick={() => setShowActionSheet(true)}>
                <IonIcon slot="icon-only" icon={ellipsisVertical}/>
            </IonButton>
        </IonButtons>

        <IonActionSheet
            isOpen={showActionSheet}
            onDidDismiss={() => setShowActionSheet(false)}
            buttons={listSettings}
        ></IonActionSheet>
    </> : null;

    const handleBackClick = (e) => {
        e.preventDefault();
        onBackButtonClick();
    }

    return <IonHeader mode="md">
        <IonToolbar className={cx("i-header", {"i-header_offline": !networkState})}>
            <IonButtons slot="start">
                {!onBackButtonClick && <IonBackButton defaultHref={`${defaultHref}`}/>}
                {onBackButtonClick && <div onTouchStart={handleBackClick} onClick={handleBackClick}>
                    <IonBackButton disabled={true} defaultHref={`${defaultHref}`}/>
                </div>}
            </IonButtons>
            {elementHeader}
            {elementSettings}
        </IonToolbar>
    </IonHeader>
};
const mapStateToProps = state => ({
    activeShop: state.Shops.activeShop,
    networkState: state.Auth.networkState,
});

export default connect(mapStateToProps)(CommonHeader);
